<div class="jumbotron text-center">
  U <strong>{{ data.occupations.length }}</strong> zábor{{ data.occupations.length === 1 ? 'u' : 'ů' }} bude nastavena cena.

  <ng-container *ngIf="data.occupationType === 'p'">
    <br>U trvalých záborů probíhá nastavování cen po listech vlastnictvcí. Bude zpracováno <strong>{{ data.titleGroups.length }}</strong> LV.
  </ng-container>

  <br>Potvrďte provedení operace.
</div>

<fieldset *ngIf="data.occupationType === 'o' || data.occupationType === 'u'">
  <div class="column-100">
    <label>Délka nájmu [<span class="unit">měsíce</span>]</label>
    <div class="info">{{ data.rentalPrice.rentalLength }}</div>
  </div>

  <div class="column-100">
    <label>Způsob určení ceny</label>
    <div class="info">{{ rentalPriceTypeTxt }}</div>

    <ng-container  *ngIf="data.rentalPrice.rentalPriceType === 'F'">
      <label>Rok cenového výměru MF</label>
      <div class="info" *ngIf="!data.useAssessment">{{ data.rentalPrice.priceAssessmentYear }}</div>
      <div class="info" *ngIf="data.useAssessment">{{ data.assessment.year }}</div>
    </ng-container>

    <ng-container  *ngIf="data.rentalPrice.rentalPriceType === 'E'">
      <label>Číslo znaleckého posudku</label>
      <div class="info">{{ data.rentalPrice.rentalExpertOpinionNumber }}</div>

      <label>Datum znaleckého posudku</label>
      <div class="info">{{ data.rentalPrice.rentalExpertOpinionDate | date }}</div>
    </ng-container>

    <ng-container  *ngIf="data.rentalPrice.rentalPriceType === 'O'">
      <label>Původ ceny</label>
      <div class="info">{{ data.rentalPrice.rentalOtherPriceSource }}</div>

      <label>Způsob výpočtu ceny</label>
      <div class="info">{{ rentalPriceUnitTxt }}</div>
    </ng-container>

    <ng-container  *ngIf="data.rentalPrice.rentalPriceType === 'O' && data.rentalPrice.rentalPriceUnit === 'T'">
      <label>Cena za pozemek [<span class="unit">Kč</span>]</label>
      <div class="info">{{ data.rentalPrice.totalRentPrice| number | price : false }}</div>
    </ng-container>

    <ng-container *ngIf="data.rentalPrice.rentalPriceType == 'F' && !data.useAssessment">
      <label>Cena za pozemek [<span class="unit">Kč/m<sup>2</sup>/rok</span>]</label>
      <div class="info">{{ data.rentalPrice.priceAssessmentLandPrice| number | price : false }}</div>
    </ng-container>

    <ng-container *ngIf="data.rentalPrice.rentalPriceType == 'F' && data.useAssessment">
      <label>Cena za pozemek [<span class="unit">Kč/m<sup>2</sup>/rok</span>]</label>
      <div class="info"><div *ngFor="let area of data.areas"><label>{{area.name}}</label><div class="info">{{data.assessment.price[area.id]}}</div></div></div>
    </ng-container>
  </div>
</fieldset>

<fieldset *ngIf="data.occupationType === 'p'">
  <div class="column-100">
    <label>Cena za pozemek</label>
    <div class="info">{{ data.purchasePrice.price }} <span class="unit"> Kč<ng-container *ngIf="data.purchasePrice.priceUnit === 'M'">/m<sup>2</sup></ng-container></span></div>

    <label>Původ ceny</label>
    <div class="info">{{ data.purchasePrice.otherSource }}</div>
  </div>
</fieldset>

<div class="mt-10">
  <gmt-button [clickAction]="onSubmit" [gmtDisabled]="!isValid">Uložit</gmt-button>
</div>
